import React, {Component} from 'react';

import {Button, ButtonToolbar, Navbar, Nav, NavDropdown, Card, Row, Col} from 'react-bootstrap';

import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from "prop-types";
import PreviousSessionsProfile from "./PreviousSessions";

import job_rules from "./tasks";
//import job_groups from "./jobs";

import {useHistory, Link} from 'react-router-dom';

const PreviousSessionsTablePropTypes = {


    sessions: PropTypes.array,
    makeSessionActive: PropTypes.func.isRequired,
    deleteSession: PropTypes.func.isRequired,

}




class PreviousSessionsTable extends Component {


    constructor(props) {
        super(props);


    }



    id_formatter(cell, row, rowIndex, cbk)
    {
        console.log("formatextradata");
        console.log(cbk);

        //return <Button onClick={()=>cbk(cell)}><b>{cell}</b></Button>
        return <div>
            <Link to={{pathname: "/nools", state: {noolsStartPath: "/saved_difficulties"}}} tabindex={-1}><Button onClick={()=> {
            console.log("onClick with cell:");
            console.log(cell);
            cbk(cell, "SEL");
        }} ><b>Review</b></Button></Link>

            {/*<Link to={{pathname: "/revise_difficulties"}} tabindex={-1}><Button onClick={()=> {*/}
            {/*    console.log("onClick with cell:");*/}
            {/*    console.log(cell);*/}
            {/*    cbk(cell, "SEL");*/}
            {/*}} ><b>{"Revise"}</b></Button></Link>*/}

            {/*<Link to={{pathname: "/saved_difficulties"}} tabindex={-1}><Button onClick={()=> {*/}
            {/*    console.log("onClick with cell:");*/}
            {/*    console.log(cell);*/}
            {/*    cbk(cell, "DEL");*/}
            {/*}} ><b>{"Delete"}</b></Button></Link>*/}

        </div>
    }
    title_formatter(cell, row, rowIndex, formatExtraData)
    {
        return <div>{cell}</div>
    }

    diff_formatter(cell, row, rowIndex, formatExtraData)
    {
        return <div>{JSON.stringify(cell).replace('[','').replace(']','').replace(/"/g,'').replace(/,/g, ", ")}</div>
    }

    task_formatter(cell, row, rowIndex, formatExtraData)
    {

        const taskNames = Array.from(new Set(
            cell.map(key => {
                try {
                    return job_rules[key]?.task || `TASK(${key})`;
                } catch {
                    return `Error (${key})`;
                }
            })
        ));

        return <div>{taskNames.join(", ")}</div>
    }

    // task_formatter(cell, row, rowIndex, formatExtraData) {
    //     const keys = JSON.stringify(cell)
    //         .replace('[','')
    //         .replace(']','')
    //         .replace(/"/g,'')
    //         .split(',')
    //         .map(k => k.trim())
    //         .filter(Boolean);
    //
    //     const taskNames = keys.map(key => {
    //         try {
    //             return job_rules[key]?.task?.name || `Unknown (${key})`;
    //         } catch {
    //             return `Error (${key})`;
    //         }
    //     });
    //
    //     console.log(keys);
    //     console.log(taskNames);
    //
    //
    //     return <div>{taskNames.join(", ")}</div>;
    // }

    assessmentInfoInitials_formatter(cell, row, rowIndex, formatExtraData) {
        try {
            return <div>{cell?.employeeInitials || "—"}</div>;
        } catch {
            return <div>—</div>;
        }
    }

    assessmentInfoPurpose_formatter(cell, row, rowIndex, formatExtraData) {
        try {
            return <div>{cell?.purpose || "—"}</div>;
        } catch {
            return <div>—</div>;
        }
    }

    render() {

        // const products = [ {id:0, name:'apples', price:1}, {id:1, name:'oranges', price:2}, {id:2, name:'door hinges', price:3} ];
        // const columns = [{
        //     dataField: 'id',
        //     text: 'Product ID'
        // }, {
        //     dataField: 'name',
        //     text: 'Product Name'
        // }, {
        //     dataField: 'price',
        //     text: 'Product Price'
        // }];

        const columns = [
            {
                dataField: 'id',
                text: 'Results',
                formatter: this.id_formatter,
                //sort: true,
                //formatExtraData: (c)=>this.props.makeSessionActive(c, ()=>useHistory().push('/nools') ),
                formatExtraData: (c, method)=> {
                    if(method==="SEL")
                        return this.props.makeSessionActive(c, ()=>console.log("pretend new page loaded") )
                    else if(method==="DEL")
                        return this.props.deleteSession(c)
                },
                headerStyle: (column, colIndex) => {
                    return { width: '100px' };
                },
            },
            {
                dataField: 'title',
                text: 'Date/Time',
                formatter: this.title_formatter,
                sort: true,
                sortValue: (cell, row) => {
                    try {
                        // Parse to timestamp
                        return new Date(cell).getTime();
                    } catch {
                        return 0; // fallback for invalid dates
                    }
                },
                sortCaret: (order, column) => {
                    if (!order) return <span>&nbsp;&nbsp;⇅</span>;
                    else if (order === 'asc') return <span>&nbsp;&nbsp;↑</span>;
                    else if (order === 'desc') return <span>&nbsp;&nbsp;↓</span>;
                    return null;
                }
            },
            // {
            //     dataField: 'difficulties',
            //     text: 'Difficulties',
            //     formatter: this.diff_formatter
            // },
            {
                //assessmentInfo:{purpose:"", employeeInitials:""},
              dataField: 'assessmentInfo',
              text: 'Initials',
              formatter: this.assessmentInfoInitials_formatter
            },
            {
                //assessmentInfo:{purpose:"", employeeInitials:""},
                dataField: 'assessmentInfo',
                text: 'Purpose',
                formatter: this.assessmentInfoPurpose_formatter
            },
            {
                dataField: 'tasks',
                text: 'Tasks',
                formatter: this.task_formatter
            },
            ];

        return(

            <BootstrapTable keyField='id' data={ this.props.sessions } columns={ columns }
                            defaultSorted={[{
                                dataField: 'title',
                                order: 'desc'
                            }]}
                            // bodyStyle={ {overflowWrap: 'break-word' } }
            />

        );

    }

}

PreviousSessionsTable.propTypes = PreviousSessionsTablePropTypes;


export default PreviousSessionsTable;
